import request from './request'

// 人才相关接口
export const talentApi = {
  // 获取人才总量详情
  getIndexDetail() {
    return request({
      url: '/external/index/indexDetail',
      method: 'get'
    })
  },
  getSubIndexList() {
    return request({
      url: '/external/index/subIndexList',
      method: 'get'
    })
  },
  subIndexListByParentId(id) {
    return request({
      url: '/external/index/subIndexListByParentId',
      method: 'get',
      params: {
        parentId: id,
      }
    })
  },
  getIndexDetailByIndexId(id) {
    return request({
      url: '/external/index/subIndexListDetailByParentId',
      method: 'get',
      params: {
        indexId: id,
      }
    })
  },


  querySchoolByProvince(indexId) {
    return request({
      url: 'system/major/provinceList/'+indexId,
      method: 'get',
      params: {
        indexId: indexId,
      }
    })
  },
  queryAllSchool(indexId) {
    return request({
      url: 'system/major/list?pageNum=1&pageSize=2000',
      method: 'get',
      params: {
        type: indexId,
      }
    })
  },


  queryInfoByModule(indexId) {
    return request({
      url: 'system/major/countByType/'+indexId,
      method: 'get',
      params: {
        indexId: indexId,
      }
    })
  },



  querySchoolData(data, pageNo, pageSize) {
    return request({
      url: '/system/major/list?pageNum=' + pageNo + '&pageSize=' + pageSize,
      method: 'get',
      params: data
    })
  },
  querySpecialList(data,pageNo, pageSize) {
    return request({
      url: '/system/major/major4List/'+data.type+'?pageNum=' + pageNo + '&pageSize=' + pageSize,
      method: 'get',
      params: data
    })
  },
  querySchoolBySpecialId(indexId,pageNo, pageSize) {
    return request({
      url: '/system/major/major4List/'+indexId+'?pageNum=' + pageNo + '&pageSize=' + pageSize,
      method: 'get'
    })
  },
  querySchoolBySpecialShoolName(majorName,type,pageNo, pageSize) {
    return request({
      url: '/system/major/schoolListByMajor?pageNum=' + pageNo + '&pageSize=' + pageSize,
      method: 'get' ,
      params: {
        majorName: majorName,
        type:type,
        schoolLevel:'本科'
      }
    })
  },
  
  exportSchool(data) {
    return request({
      url: '/system/major/exportSchool',
      method: 'post',
      params: data,
      responseType: 'blob'
    })
  },
  getRecruitCalendar() {
    return request({
      url: '/system/calendar/listAll',
      method: 'get',
      params: {
      }
    })
  }

}

